import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const schema = yup.object({
  customer_name: yup.string().required('Customer name is required'),
  mobile: yup.string()
    .matches(/^[6-9]\d{9}$/, 'Invalid Indian mobile number')
    .required('Mobile number is required'),
  aadhaar_last4: yup.string()
    .matches(/^\d{4}$/, 'Must be exactly 4 digits')
    .required('Aadhaar last 4 digits required'),
  transaction_type: yup.string().required('Transaction type is required'),
  amount: yup.number().positive('Amount must be positive').required('Amount is required'),
  commission: yup.number().min(0, 'Commission cannot be negative'),
});

const AddTransaction = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await axios.post('http://localhost/saininewsite/backend/add_transaction.php', data);
      if (response.data.success) {
        alert('Transaction added successfully!');
        reset();
        navigate('/transactions/view');
      }
    } catch (error) {
      const message = error.response?.data?.error || 'Error adding transaction';
      alert(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="card p-6"
      >
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
          Add New Transaction
        </h1>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Customer Name *
              </label>
              <input
                {...register('customer_name')}
                type="text"
                className="input-field"
                placeholder="Enter customer name"
              />
              {errors.customer_name && (
                <p className="mt-1 text-sm text-red-600">{errors.customer_name.message}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Mobile Number *
              </label>
              <input
                {...register('mobile')}
                type="tel"
                className="input-field"
                placeholder="Enter mobile number"
              />
              {errors.mobile && (
                <p className="mt-1 text-sm text-red-600">{errors.mobile.message}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Aadhaar Last 4 Digits *
              </label>
              <input
                {...register('aadhaar_last4')}
                type="text"
                maxLength="4"
                className="input-field"
                placeholder="Enter last 4 digits"
              />
              {errors.aadhaar_last4 && (
                <p className="mt-1 text-sm text-red-600">{errors.aadhaar_last4.message}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Transaction Type *
              </label>
              <select {...register('transaction_type')} className="input-field">
                <option value="">Select type</option>
                <option value="deposit">Deposit</option>
                <option value="withdraw">Withdraw</option>
              </select>
              {errors.transaction_type && (
                <p className="mt-1 text-sm text-red-600">{errors.transaction_type.message}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Amount *
              </label>
              <input
                {...register('amount')}
                type="number"
                step="0.01"
                className="input-field"
                placeholder="Enter amount"
              />
              {errors.amount && (
                <p className="mt-1 text-sm text-red-600">{errors.amount.message}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Commission
              </label>
              <input
                {...register('commission')}
                type="number"
                step="0.01"
                defaultValue="0"
                className="input-field"
                placeholder="Enter commission"
              />
              {errors.commission && (
                <p className="mt-1 text-sm text-red-600">{errors.commission.message}</p>
              )}
            </div>
          </div>

          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={() => navigate('/transactions/view')}
              className="btn-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary disabled:opacity-50"
            >
              {loading ? 'Adding...' : 'Add Transaction'}
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
};

export default AddTransaction;
